<template>
  <div style="margin:auto;">
    <div @click="returnToday()" class="today-label">
      <div class="name">{{$anm22.strLang(lang, 'Today', 'Oggi') }}</div>
    </div>
    <div style="display:grid;">
      <div class="vertical-height-div" style="height:5px;"></div>
      <div id="mapQ_canvas" class="container-map com-anm22-app-scrolling-panel">
        <div id="task-gant-scroll" :style="{ width: totalDaysInGantt * 30 + 'px'}">
          <div class="today" :style="{left: leftFromData($moment().unix())  + 'px'}"></div>
          <div class="header">
            <div v-for="(element, index) in tasksGantt" :key="'grid-head-'+index">
              <div class="gantt-month">{{element.months.format("MMM YYYY").toUpperCase()}}</div>
              <div class="wg-row wg-day" style="flex-wrap:nowrap;">
                <div
                  v-for="days in element.arrDays"
                  :class="['day-list',element.months.daysInMonth() == days ? 'last-day' : '']"
                  :key="'days-'+days"
                >{{ days }}</div>
              </div>
            </div>
          </div>
          <svg 
            v-for="fts in tasksDependenciesLines()" :key="'fts-'+fts.startRow+'-'+fts.endRow"
            class="fts-line"
            :height="[ftsDrawExternalContainerHeight(fts)]"
            :width="[ftsDrawExternalContainerWidth(fts)]"
            :style="{left:(ftsDrawExternalContainerPosX(fts)-30)+'px',top:ftsDrawExternalContainerPosY(fts)+'px',width:(ftsDrawExternalContainerWidth(fts)+60)+'px',height:ftsDrawExternalContainerHeight(fts)+'px'}"
            >
            <path :d="[ftsGetPathPnts(fts)]" />
          </svg>
          <div style="padding:5px 0;z-index:1" v-for="task in tasksDataNew()" :key="'task-'+task.id">
            <div
              :id="'taskid_'+task.id"
              v-bind:style="{width: totalDaysInGantt * 30 + 'px'} "
              class="task-line"
            >
              <div
                @click="$emit('open-task', task.id)"
                :class="['task',taskStyleClass(task)]"
                :title="taskTitle(task)"
                :style="{width: taskWidth(task) + 'px', left: taskPosition(task)  + 'px'}"
              >
                <div class="wg-row" style="align-items:center;height:100%;flex-wrap:nowrap;">
                  <img
                    class="com-anm22-app-img-fixed-height-s"
                    :src="getPriorityIcon(task.priority)"
                  />
                  <div class="task-name">{{ task.name }}</div>
                  <div class="display-flex users-div">
                    <div v-for="(user,index) in taskUsers(task)" :key="'u-'+index">
                      <world-object-icon :type="'user'" :obj="user" :isImg="true"></world-object-icon>
                    </div>
                    <div v-for="(job,index) in taskJobs(task)" :key="'job'+index">
                      <div :title="$anm22.strLang(lang, job.en, job.it)" class="job-icon"> {{ $anm22.strLang(lang, job.en, job.it).substring(0,1).toUpperCase() }} </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    tasksData: {
      type: Array,
      required: true
    },
    boardOpen: {
      type: Boolean,
      default: false
    },
    project: Object
  },
  data() {
    return {
      yearOffset: 0
    };
  },
  components: {},
  computed: {
    ...mapState({
      windowWidth: state => state.windowWidth,
      user: state => state.auth.user,
      lang: state => state.lang
    }),
    totalDaysInGantt() {
      let ganttInterval = this.ganttInterval;
      let startDay = ganttInterval.start;
      let endDay = ganttInterval.end;
      let totalDaysInGantt = endDay.diff(startDay, "days");
      return totalDaysInGantt + 1;
    },
    ganttInterval() {
      //Inizio progetto
      let startDay = this.project.startDate;
      // Fine progetto
      let endDay = this.project.endDate;
      let projectEnd = this.$moment.unix(endDay).format("YYYY-MM-DD");
      //Fine progetto maggiore del giorno corrente e ancora in corso,la fine sarà settata come il giorno corrente
      
      this.tasksData.forEach(task => {
        if (task.startDate != "" && task.startDate < startDay) {
          //Controllo che ci sia un task che abbia inizio minore dell'inizio del progetto
          startDay = task.startDate;
        } else if (task.deadline != "" && task.deadline < startDay) {
          //Controllo che ci sia un task che abbia fine minore dell'inizio del progetto
          startDay = task.deadline;
        }
        //Controllo che ci sia un task che abbia fine maggiore della fine del progetto
        if (task.deadline != "" && task.deadline > endDay) {
          endDay = task.deadline;
        } else if (task.startDate != "" && task.startDate > endDay) {
          //Controllo che ci sia un task che abbia inizio maggiore della fine del progetto
          endDay = task.startDate;
        }
      });
      let currentDate = new Date();
      if (((this.project.status != 3) && (this.project.status != 4) && (this.project.status != 5)) && new Date(endDay*1000) < currentDate) {
        endDay = this.$moment().unix();
      }
      //Pulisco i risultati per evitare problemi con il timezone
      let startDateString = this.$moment.unix(startDay).format("YYYY-MM-DD");
      startDay = this.$moment(new Date(startDateString)).add(-3, "days");
      let endDateString = this.$moment.unix(endDay).format("YYYY-MM-DD");
      endDay = this.$moment(new Date(endDateString)).add(3, "days");
      return { start: startDay, end: endDay };
    },
    tasksGantt() {
      let result = [];
      let ganttInterval = this.ganttInterval;
      //let startDay = this.year.clone().startOf("year");
      // let projectStart = this.$moment.unix(this.project.startDate).format("YYYY-MM-DD");
      // let startDay = this.$moment(new Date(projectStart));
      // let projectEnd = this.$moment.unix(this.project.deadline).format("YYYY-MM-DD");
      // //let startDay= this.$moment(this.project.startDate)
      // //console.log(startDay)
      // let endDay =this.$moment(new Date(projectEnd));
      let startDay = ganttInterval.start;
      let endDay = ganttInterval.end;
      let date = startDay.clone().subtract(1, "month");
      while (date.isBefore(endDay, "month")) {
        let months = date.add(1, "month").clone();
        let daysInMonth = months.daysInMonth();
        let arrDays = [];
        let i = 1;
        //Se sono al primo mese inizio con il giorno ricavato dal metodo ganttInterval
        if (months.isSame(startDay, "month")) {
          i = Number(startDay.format("D"));
        }
        //Se sono all'ultimo mese finisco con il giorno ricavato dal metodo ganttInterval
        if (months.isSame(endDay, "month")) {
          daysInMonth = Number(endDay.format("D"));
        }
        for (i; i <= daysInMonth; i++) {
          var current = i;
          arrDays.push(current);
        }
        result.push({
          months: months,
          daysInMonth: daysInMonth,
          arrDays: arrDays
        });
      }
      return result;
    }
  },

  methods: {
    isSynchronized(task) {
      return this.$store.getters["offline/isSynchronized"](
        this.$anm22.MD5("Worldtask" + task.id)
      );
    },
    returnToday() {
      this.scroll();
    },
    getPriorityIcon(id) {
      switch (id) {
        case 1:
          return this.$anm22.icons.getWorldIcon("priorityLowest");
        case 2:
          return this.$anm22.icons.getWorldIcon("priorityLow");
        case 3:
          return this.$anm22.icons.getWorldIcon("priorityMedium");
        case 4:
          return this.$anm22.icons.getWorldIcon("priorityHigh");
        case 5:
          return this.$anm22.icons.getWorldIcon("priorityHighest");
      }
    },
    tasksDataNew() {
      let scriptData = { newList: [], antiLoopArray: [] };
      this.tasksData.forEach(task => {
        scriptData = this.cicleTasks(task, scriptData);
      });
      return scriptData.newList;
    },
    cicleTasks(task, scriptData) {
      let lastParent = null;
      //Controllo che il task analizzato non sia gia presente nell'array
      if (!scriptData.newList.find(t => t.id === task.id)) {
        // Controllo se sto entrando in un loop
        if (scriptData.antiLoopArray.find(id => id == task.id)) {
          return scriptData;
        }
        scriptData.antiLoopArray.push(task.id); // Inserisco task nell'array anti loop
        //Ciclo le dipendenze e richiamo cicleTasks per ognuna
        if (task.fts.length > 0) {
          task.fts.forEach(t => {
            let ftsTask = this.tasksData.find(task => task.id == t);
            if (ftsTask) {
              scriptData = this.cicleTasks(ftsTask, scriptData);
            }
            lastParent = t;
          });
        }
        if (!lastParent) {
          scriptData.newList.push(task);
        } else {
          let parentIndex = scriptData.newList.findIndex(
            p => p.id === lastParent
          );
          scriptData.newList.splice(parentIndex + 1, 0, task);
        }
        scriptData.antiLoopArray.pop();
      }
      return scriptData;
    },
    tasksDependenciesLines() {
      let tasksPos = {};
      let taskRow = 0;
      let ftsList = [];
      let taskPos, taskEnd, i;
      // Scorro tutti i task per memorizzare la posizione
      this.tasksDataNew().forEach(task => {
        taskPos = this.taskPosition(task);
        taskEnd = taskPos + this.taskWidth(task);
        tasksPos[task.id] = {pos:taskPos,end:taskEnd,row:taskRow};
        if (task.fts) {
          for (i=0;i<task.fts.length;i++) {
            ftsList.push({startTaskId: task.fts[i], endTaskId: task.id});
          }
        }
        taskRow++;
      });
      ftsList.forEach((fts,key) => {
        if (tasksPos[fts.startTaskId]) {
          ftsList[key].startRow = tasksPos[fts.startTaskId].row;
          ftsList[key].startPos = tasksPos[fts.startTaskId].end;
          ftsList[key].endRow = tasksPos[fts.endTaskId].row;
          ftsList[key].endPos = tasksPos[fts.endTaskId].pos;
        } else {
          // In caso di task cancellato
          ftsList[key].startRow = 0;
          ftsList[key].startPos = 0;
          ftsList[key].endRow = 0;
          ftsList[key].endPos = 0;
        }
      });
      return ftsList;
    },
    taskUsers(task) {
      return task.users.map(u => this.$store.getters["users/get"](u));
    },
    taskGanttDayStart(task) {
      let res = 0;
      //Se c'è una data di inizio impostata il task verrà posizionato in base a quella
      if (task.startDate != "") {
        res = task.startDate;
      }
      //Se non c'è una data di inizio settata ma il task ha dipendenze,questo viene collocato dopo la fine di quel task,in caso di multidipendenza
      // viene preso il primo task con la deadline settata,altrimenti la deadline sarà l'inizio del task.Se non e settato nemmeno l'inizio verra collocato al giorno seguente.
      else if (task.startDate == "" && task.fts.length > 0) {
        let deadline = 0;
        let taskFindWithDeadline = this.tasksData.find(
          t => t.deadline != "" && task.fts.find(id => t.id == id)
        );
        if (taskFindWithDeadline) {
          deadline = taskFindWithDeadline.deadline;
          // I progetti non completati devono arrivare fino al giorno corrente
          if ((taskFindWithDeadline.status != 3) && (deadline < this.$moment().unix())) {
            deadline = this.$moment().unix();
          }
        } else {
          let taskFindWithStartDate = this.tasksData.find(
            t => t.startDate != "" && task.fts.find(id => t.id == id)
          );
          if (taskFindWithStartDate) {
            deadline = taskFindWithStartDate.startDate;
            // I progetti non completati devono arrivare fino al giorno corrente
            if ((taskFindWithStartDate.status != 3) && (deadline < this.$moment().unix())) {
              deadline = this.$moment().unix();
            }
          } else {
            deadline = this.$moment().unix();
          }
        }
        res = deadline;
      }
      //Se la data di inizio non è settata e il task non ha dipendenze,il task viene collocato nel giorno corrente
      else if (task.startDate === "" && task.fts.length === 0) {
        res = this.$moment().unix();
      }
      return res;
    },
    taskWidth(task) {
      //Inizio e deadline di default sono il giorno corrente
      let stDate = this.taskGanttDayStart(task);
      let endDate = this.$moment().unix();
      //Se la deadline non è impostata, utilizzo il giorno di inizio
      if (task.deadline == "") {
        endDate = stDate;
      } else {
        endDate = task.deadline;
      }
      // I progetti non completati devono arrivare fino al giorno corrente
      if ((task.status != 3) && (endDate < this.$moment().unix())) {
        endDate = this.$moment().unix();
      }
      return this.widthFromData(stDate, endDate);
    },
    taskPosition(task) {
      return this.leftFromData(this.taskGanttDayStart(task));
    },
    taskJobs(task) {
      let project = this.$store.getters['projects/get'](this.project.idWorldProject);
      let licenses = project.developers
        .map(w => this.$store.getters["licenses/get"](w))
        .filter(l => l);
      let jobs =  licenses.reduce(
        (acc, license) =>
          acc.concat(
            license.config && license.config.tasks && license.config.tasks.jobs
          ),
        []
      );
      return task.jobs.map(taskJob =>
        jobs.find(j => j.id === taskJob)
      )

    },
    taskTitle(task){
      let usersNames = task.users.map( u => this.$store.getters['users/get'](u).name + ' ' + this.$store.getters['users/get'](u).surname);
      let tJobs = this.taskJobs(task)
      let taskJobsName = tJobs.map(job => job[this.lang]);
      let string = task.name ;
      if(usersNames.length > 0) {
       string+=  '\n- ' + usersNames.join('\n- ')
      }
      if(taskJobsName.length > 0) {
       string+=  '\n- ' + taskJobsName.join('\n- ') 
      }
      return string;
    },
    taskStyleClass(task) {
      switch (task.status) {
        case 1:
          return "waiting";
        case 2:
          return "running";
        case 3:
          return "completed";
        case 4:
          return "invoiced";
        case 5:
          return "deleted";
        case 6:
          return "provisional";
      }
    },
    widthFromData(from, to) {
      var from = this.$moment.unix(from).format("YYYY-MM-DD");
      var to = this.$moment.unix(to).format("YYYY-MM-DD");
      let dateFrom = this.$moment(new Date(from));
      let dateTo = this.$moment(new Date(to));
      var diff = dateTo.diff(dateFrom, "days") + 1; //calcolo differenza giorni
      return this.daysToPixel(diff); //ritorno i giorni in pixel
    },
    leftFromData(from) {
      let dataFrom = this.$moment.unix(from).format("YYYY-MM-DD");
      let startYear = this.ganttInterval.start.format("YYYY-MM-DD");
      let dateFrom = this.$moment(new Date(dataFrom));
      var diff = dateFrom.diff(startYear, "days") + 1;
      return this.dayToPosX(diff);
    },
    dayToPosX(day) {
      return (day - 1) * 30;
    },
    daysToPixel(days) {
      return days * 30;
    },
    scroll() {
      let left = this.leftFromData(this.$moment().unix());
      document.getElementById("mapQ_canvas").scrollLeft = left - 30 * 2;
    },
    ftsDrawExternalContainerWidth(fts) {
      if (fts.startPos < fts.endPos) {
        let drawWidth = fts.endPos-fts.startPos;
        return drawWidth;
      } else {
        let drawWidth = fts.startPos-fts.endPos;
        return drawWidth;
      }
    },
    ftsDrawExternalContainerHeight(fts) {
      return (((fts.startRow < fts.endRow)?fts.endRow-fts.startRow:fts.startRow-fts.endRow)*40);
    },
    ftsDrawExternalContainerPosX(fts) {
      return ((fts.startPos < fts.endPos)?fts.startPos:fts.endPos);
    },
    ftsDrawExternalContainerPosY(fts) {
      return (73+((fts.startRow < fts.endRow)?fts.startRow:fts.endRow)*40);
    },
    ftsGetPathPnts(fts) {
      let x1,y1,x2,y2;
      if (fts.startPos < fts.endPos) {
        x1 = 30;
        x2 = this.ftsDrawExternalContainerWidth(fts) + 30;
      } else {
        x1 = this.ftsDrawExternalContainerWidth(fts) + 30;
        x2 = 30;
      }
      if (fts.startRow < fts.endRow) {
        y1 = 1;
        y2 = this.ftsDrawExternalContainerHeight(fts) - 1;
      } else {
        y1 = this.ftsDrawExternalContainerHeight(fts) + 1;
        y2 = 1;
      }
      return 'M'+x1+','+y1+' C'+(x1+30)+','+y1+' '+(x2-30)+','+y2+' '+x2+','+y2;
    }
  },

  created() {},

  mounted() {
    setTimeout(
      function() {
        this.scroll();
      }.bind(this),
      1000
    );
  }
};
</script>
<style lang="scss" scoped>
.container-map {
  overflow-x: auto;
  overflow-y: hidden;
  background-color: #fff;
  border-radius: 6px;
}
.last-day {
  color: red;
}
.today-label {
  padding: 5px 10px;
  display: inline-block;
  vertical-align: middle;
  font-size: 14px;
  cursor: pointer;
  background-color: #ddd;
  border-radius: 20px;
}
.today-label .name {
  font-size: 15px;
  color: #222;
}
.today-label:hover {
  background-color: #ccc;
}
#task-gant-scroll {
  position: relative;
  overflow: hidden;
  background-position: 0px 0px;
  background-repeat: repeat;
  background-size: 25px auto;
}
.today {
  background-color: #eee;
  top: 22px;
  font-size: 13px;
  text-align: center;
  width: 30px;
  border-radius: 4px;
  position: absolute;
  height: 100000000000px;
}

.user-icon {
  margin-left: 5px;
  vertical-align: middle;
  border-radius: 29px;
  width: 20px;
  height: 20px;
  display: inline-block;
}
.users-name {
  max-width: 100px;
  margin-left: 5px;
  vertical-align: middle;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  display: inline-block;
}

.task-line {
  position: relative;
  height: 30px;
  box-sizing: border-box;
  font-size: 12px;
  cursor: default;
}
.users-menu {
  padding-top: 72px;
  float: left;
  border-right: 1px solid #eee;
  width: 155px;
}
.com-anm22-app-custom-scroll::-webkit-scrollbar,
.com-anm22-app-scrolling-panel::-webkit-scrollbar {
  height: 20px;
}
.users-label {
  width: 155px;
  font-size: 14px;
  display: inline-block;
  padding: 10px 5px 5px 5px;
  height: 40px;
  cursor: default;
  text-align: left;
  font-weight: normal;
  vertical-align: middle;
  box-sizing: border-box;
}
.users-div {
  height: 26px;
  flex-wrap: nowrap;
  align-items: center;
  white-space: nowrap;
  box-sizing: border-box;
  position: relative;
  margin-right: 10px;
  flex: 1;
}
.users-div > div {
  position: absolute;
  min-width: 26px;
  width: 26px;
  height: 26px;
  display: block;
  border: 2px solid #fafafa;
  border-radius: 13px;
  top: 0px;
  left: 0px;
}
.users-div > div:nth-child(1) {
  left: 0px;
  z-index: 11;
}
.users-div > div:nth-child(2) {
  left: 20px;
  z-index: 10;
}
.users-div > div:nth-child(3) {
  left: 40px;
  z-index: 9;
}
.users-div > div:nth-child(4) {
  left: 60px;
  z-index: 8;
}
.users-div > div:nth-child(5) {
  left: 80px;
  z-index: 7;
}
.users-div > div:nth-child(6) {
  left: 100px;
  z-index: 6;
}
.users-div > div:nth-child(7) {
  left: 120px;
  z-index: 5;
}
.users-div > div:nth-child(8) {
  left: 140px;
  z-index: 4;
}
.users-div > div:nth-child(9) {
  left: 160px;
  z-index: 3;
}
.users-div > div:nth-child(10) {
  left: 180px;
  z-index: 2;
}
.head-menu {
  position: relative;
  height: 30px;
  box-sizing: border-box;
  line-height: 1;
  font-size: 18px;
}
.head-menu .anm22-calendar-change-month-button {
  top: 4px;
}
.header {
  display: block;
  text-align: left;
  font-size: 0;
  border-bottom: 1px solid #eee;
  white-space: nowrap;
  line-height: 1;
}
.header > div {
  display: inline-block;
  text-transform: uppercase;
  font-size: 11px;
  font-weight: bold;
  overflow: hidden;
  position: relative;
  padding-top: 22px;
}
.gantt-month {
  height: 22px;
  padding: 8px 4px 0 4px;
  overflow: hidden;
  position: absolute;
  top:0;
  width:100%;
}
.wg-day {
  height: 30px;
  text-align: center;
  flex-wrap: nowrap;
}

.task-name {
  padding: 2px;
}

.day-list {
  margin: auto;
  width: 30px;
  z-index: 10;
  cursor: default;
}

.task {
  height: 30px;
  cursor: pointer;
  box-sizing: border-box;
  border-radius: 20px;
  position: absolute;
  top: 0px;
  white-space: nowrap;
  overflow: hidden;
  line-height: 1;
  font-size: 14px;
  border: 2px solid #eee;
}
.task.waiting {
  background: #bdbdbd;
  border-color: #a3a3a3;
}
.task.waiting .users-div > div {
  border-color: #bdbdbd;
}
.task.running {
  background: #ffeb3b;
  border-color: #d6c100;
}
.task.running .users-div > div {
  border-color: #ffeb3b;
}
.task.completed {
  background: #01d479;
  border-color: #01a25c;
}
.task.completed .users-div > div {
  border-color: #01d479;
}

.fts-line {
  position: absolute;
  z-index: 0;
}
.fts-line path {
  stroke-width: 2;
  stroke: #ccc;
  stroke-linecap: round;
  fill: none;
}
div.job-icon {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  color: #fff;
  background-color: #007fff;
  border-radius: 50%;
  user-select: none;
  font-size: 14px;
}
.job-icon {
  width: 100%;
  height: 100%;
  padding: 0;
}
</style>



